module.exports = __webpack_public_path__ + "static/media/slide-earning-white.4611e59e.png";